import { API_URL } from "./../../utils/api-utils";

export const url = `${API_URL.Query}/hubs/query`;
export const method = "UpdateExportHistoryList"
